import React from "react";
import styled from "styled-components";
import {NavLink} from "react-router-dom";
import iconChevron from "assets/icons/icon_chevron_black.svg";

export const More = ({icon, title, text, href, ...props}) => {
	const img = (icon) ? <img src={icon} alt={title} /> : null;
	title = (
		<h4>
			<span>{img}{title}</span>
			<span>{text}</span>
		</h4>
	);
	return (
		<Wrapper>
			{
				(href) ? (<NavLink to={href}>{title}</NavLink>) :
				(props.onClick) ? (<a onClick={props.onClick}>{title}</a>) : title
			}
			{(props.children) ? props.children : null}
		</Wrapper>
	);
};

const Wrapper = styled.div`
	a				{display:block; margin:0 -5px; padding:5px 20px 5px 5px; background:url(${iconChevron}) no-repeat center right 5px}
	h4				{display:flex; align-items:center; justify-content:space-between; letter-spacing:-0.2px; line-height:1; font-weight:700}
	h4 img			{display:inline-block; margin:0 6px 0 -2px}
	h4 span			{/*display:inline-flex; align-items:center*/}
	h4 span + span	{font-size:var(--16px)}		
`;

export default More;